import { Link } from 'react-router-dom';

function inline(text) {
  const parts = String(text || '').split(/(\[[^\]]+\]\([^)]+\)|\*\*[^*]+\*\*|\*[^*]+\*)/g);
  return parts.map((part, index) => {
    const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (link) {
      const [, label, href] = link;
      const isExternal = /^https?:\/\//.test(href);
      if (isExternal) return <a key={index} href={href} className="text-[#f97316] hover:text-white underline underline-offset-4">{label}</a>;
      return <Link key={index} to={href} className="text-[#f97316] hover:text-white underline underline-offset-4">{label}</Link>;
    }
    if (/^\*\*[^*]+\*\*$/.test(part)) return <strong key={index} className="text-white">{part.slice(2, -2)}</strong>;
    if (/^\*[^*]+\*$/.test(part)) return <em key={index}>{part.slice(1, -1)}</em>;
    return part;
  });
}

export default function MarkdownArticle({ markdown = '', skipCta = true }) {
  const lines = markdown.split(/\r?\n/);
  const blocks = [];
  let current = [];

  const flush = () => {
    if (current.length) {
      blocks.push({ type: 'p', text: current.join(' ') });
      current = [];
    }
  };

  lines.forEach((line) => {
    if (skipCta && /^## Ready to meet the stranger side/.test(line)) {
      flush();
      blocks.push({ type: 'skip-until-faq' });
      return;
    }
    if (blocks.at(-1)?.type === 'skip-until-faq' && !/^## FAQ/.test(line)) return;
    if (/^# /.test(line)) { flush(); return; }
    if (/^## /.test(line)) { flush(); blocks.push({ type: 'h2', text: line.replace(/^## /, '') }); return; }
    if (/^### /.test(line)) { flush(); blocks.push({ type: 'h3', text: line.replace(/^### /, '') }); return; }
    if (!line.trim()) { flush(); return; }
    current.push(line.trim());
  });
  flush();

  return (
    <div className="prose prose-invert max-w-none text-[#dcd6e6] leading-relaxed">
      {blocks.filter((b) => b.type !== 'skip-until-faq').map((block, index) => {
        if (block.type === 'h2') return <h2 key={index} className="font-heading text-3xl mt-10 mb-4 text-white">{inline(block.text)}</h2>;
        if (block.type === 'h3') return <h3 key={index} className="font-heading text-2xl mt-7 mb-3 text-white">{inline(block.text)}</h3>;
        return <p key={index} className="mb-4 text-[#c7c7c7]">{inline(block.text)}</p>;
      })}
    </div>
  );
}
